import {CostDetailItemResponseBody, CostItem} from '@dms/api/core';

import {DEFAULT_CURRENCY_CODE} from '../../../../../constants/DEFAULT_CURRENCY_CODE';

export const getCostItemsFromPreset = (presetItems?: CostDetailItemResponseBody[]): CostItem[] =>
  presetItems?.map((presetItem) => ({
    ...presetItem,
    cost: (presetItem.cost ?? 0).toString(),
    currency: presetItem.currency ?? DEFAULT_CURRENCY_CODE,
    note: presetItem.note ?? '',
  })) ?? [];
